import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import ExperienceRefundWarning from './ExperienceRefundWarning';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  experiences?: ReadonlyArray<App.ExperienceItem>;
};

function WarningExistingExperienceItems({ open, onClose, onConfirm, experiences }: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle fontSize={24} fontWeight="bold">
        Warning
      </DialogTitle>
      <DialogContent sx={{ minWidth: '400px' }}>
        <ExperienceRefundWarning experiences={experiences} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          I understand
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WarningExistingExperienceItems;
